import React from "react";
import {
  ContentWithSidebarPanel,
  IContentWithSidebarPanelProps,
} from "../../../components/panels/ContentWithSidebarPanel";

export type GetContentWithSidebarPanelProps =
  IContentWithSidebarPanelProps & { id: string };

export const getContentWithSidebarPanel = ({
  id,
  backgroundColour,
  sections,
  callToActions,
  title,
  headingType,
  headerAnchor,
  content,
}: GetContentWithSidebarPanelProps) => (
  <ContentWithSidebarPanel
    key={id}
    sections={sections}
    title={title}
    headerAnchor={headerAnchor}
    headingType={headingType}
    content={content}
    callToActions={callToActions}
    backgroundColour={backgroundColour}
  />
);
